module.exports = __webpack_public_path__ + "img/gallery-23.56ec62cd.jpg";